import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { useState } from "react";
import publicacaoService from "../services/publicacao";
import { UPLOAD_PRESETS, validateUploadFile } from "../utils/validateUploadFile";

export default function SolicitarPublicacaoModal({
  open,
  onClose,
  solicitacaoDeLicencaId,
  onSucesso,
}) {
  const [isAgricultorFamiliar, setIsAgricultorFamiliar] = useState(false);
  const [arquivo, setArquivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const reset = () => {
    setIsAgricultorFamiliar(false);
    setArquivo(null);
    setError("");
    setLoading(false);
  };

  const handleClose = () => {
    if (loading) return;
    reset();
    onClose();
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsAgricultorFamiliar(checked);
    if (!checked) setArquivo(null);
    setError("");
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0] || null;
    setError("");
    if (!file) {
      setArquivo(null);
      return;
    }

    const validation = await validateUploadFile(file, UPLOAD_PRESETS.documento);
    if (!validation.valid) {
      setArquivo(null);
      setError(validation.error);
      event.target.value = "";
      return;
    }

    setArquivo(file);
  };

  const handleSubmit = async () => {
    setError("");
    if (isAgricultorFamiliar && !arquivo) {
      setError("Envie o comprovante de agricultor familiar ou baixa renda.");
      return;
    }

    setLoading(true);
    try {
      const data = await publicacaoService.criar(
        solicitacaoDeLicencaId,
        isAgricultorFamiliar,
        arquivo,
      );
      onSucesso?.(data);
      reset();
      onClose();
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Erro ao solicitar publicação de recebimento.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Solicitar publicação de recebimento de licença</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Solicite a publicação de recebimento desta licença na aba pública de
          Publicações do Licenciar. O analista poderá cobrar taxa (boleto) ou
          efetuar a publicação diretamente.
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              checked={isAgricultorFamiliar}
              onChange={handleCheckboxChange}
              disabled={loading}
            />
          }
          label="Sou agricultor familiar ou baixa renda"
        />

        {isAgricultorFamiliar && (
          <Box sx={{ mt: 1 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Comprovante (PDF, PNG ou JPEG, máx. 10 MB) *
            </Typography>
            <Button variant="outlined" component="label" disabled={loading}>
              Selecionar arquivo
              <input
                hidden
                type="file"
                accept="application/pdf,image/png,image/jpeg,.pdf,.png,.jpg,.jpeg"
                onChange={handleFileChange}
              />
            </Button>
            {arquivo && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Arquivo: {arquivo.name}
              </Typography>
            )}
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || (isAgricultorFamiliar && !arquivo)}
        >
          {loading ? <CircularProgress size={22} color="inherit" /> : "Solicitar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
